<template>
  <div>
    <header class="Header">
      <div class="Header__inner">
        <router-link to="/" class="Header_menu__logo Header_menu__logo--sm">
          <img class="Header_menu__logo_img" src="assets/img/melon_logo_blue.png" alt="MELON ONLINE">
        </router-link>
      </div>
    </header>
    <div class="contents contents--pt">
      <section class="Form _min-h">
        <div class="inner Form__position">
          <div class="Form__thanks_area">
            <img src="assets/img/signup_thanks.png" alt="SignUp Thanks" class="register__banner_img">
            <p class="Form__tx register__banner_header">
              THANK YOU!!
            </p>
            <p class="Form__tx register__banner_header-jp">
              ご登録ありがとうございました
            </p>
            <p class="Form__thanks_tx register__banner_tx _mg-t40 _font-lg">
              ご登録いただいたメールアドレス宛に、MELONの使い方をご説明するメールをお送りいたしました。下記ログインボタンよりMELON ONLINEをお楽しみください！
            </p>
            <p class="Form__tx register__thanks_tx _mg-t40">
              まずはマインドフルチェッカーで
              <br>
              ストレス値を確認してみよう！
            </p>
            <router-link to="/signin" class="Btn__blue register__thanks_btn">
              ログインはこちら
            </router-link>
            <p class="Form__thanks_tx register__banner_tx _font-md _mg-t20">
              ※数分たってもメールが届かない場合は、お手数ですが<a href="mailto:info@the-melon.com">「info@the-melon.com」</a>へご連絡ください。
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignUpThanks'
}
</script>
